import React from 'react';

const UpgradePlanCard = ({
  handleUpgradePlan
}) => {
  if (localStorage.getItem('userTyp') == 'instafeed' && localStorage.getItem('ispaid') !== 'true') {
    document.getElementsByTagName('body')[0].classList.add('cls_wiser_insta_feed');
  }
  return (
    <div>
      {
        (localStorage.getItem('userTyp') == 'instafeed' && localStorage.getItem('ispaid') !== 'true') &&
        <a className='btn upgrde-plan-cta' type="button" onClick={() => handleUpgradePlan()}>Upgrade Plan</a>
      }
    </div>
  );
};

export default UpgradePlanCard;


// WEBPACK FOOTER //
// ./src/components/Widget/UpgradePlanCard.js